module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    ref: "selectbox",
    staticClass: "form-control sm-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputSearch),
      expression: "inputSearch"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hidePopup),
      expression: "hidePopup"
    }],
    ref: "searchInput",
    staticClass: "input-search to-click",
    attrs: {
      "type": "text",
      "placeholder": _vm.filterText,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputSearch)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showPopup($event)
      },
      "focus": function($event) {
        $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputSearch = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "pull-right caret-fixed to-click",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showPopup($event)
      }
    }
  }, [_c('b', {
    staticClass: "caret"
  })]), (_vm.popupVisible) ? _c('div', {
    directives: [{
      name: "when-scroll-ends",
      rawName: "v-when-scroll-ends",
      value: ({
        callback: _vm.loadMore
      }),
      expression: "{callback: loadMore}"
    }],
    staticClass: "sm-select-popup1 pop-up-size",
    style: ({
      width: _vm.popUpMinWidth
    })
  }, [_c('ul', _vm._l((_vm.itemsData), function(item, index) {
    return _c('ItemSelector', {
      key: index,
      attrs: {
        "useState": _vm.useState,
        "item": item,
        "field": _vm.field,
        "parseField": _vm.parseField,
        "onChange": _vm.onSelect,
        "key": "item.id"
      }
    })
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d474162"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/UniqueSelect/UniqueSelect.vue
// module id = 443
// module chunks = 2